import { AddEditHiredPlacementModal, ConfirmationModal, ErrorModal } from "components/reusables";
import { HiredTeacherPlacements } from "models";
import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { useHistory } from "react-router-dom";
import { deleteHiredStory } from "services/hiredPlacementsService";
import genericAvatar from "assets/images/generic_avatar.jpg";
import { HiredPlacementSecondaryInfo } from "../../reusables/SecondaryInfo/HiredPlacementSecondaryInfo";

interface HiredPlacementCardProps {
  hiredPlacement: HiredTeacherPlacements;
}

export function HiredPlacementCard({ hiredPlacement }: HiredPlacementCardProps): JSX.Element {
  const [isShowingConfirmDelete, setIsShowingConfirmDelete] = useState(false);
  const [isShowingEditHiredPlacementModal, setIsShowingEditHiredPlacementModal] = useState(false);
  const [isDisplaying] = useState(hiredPlacement.display);
  const [error] = useState<Error | undefined>(undefined);
  const history = useHistory();

  return (
    <>
      <Row>
        <Col xs="auto" className="d-flex align-items-center p-0" />

        <Col>
          <Card style={{ opacity: isDisplaying ? 1 : 0.5 }}>
            <Card.Body>
              <Row>
                <Col xs={3} md={2} className="d-flex align-items-center">
                  <div className="img-square-container">
                    <Img
                      src={hiredPlacement.photoUrl || ""}
                      placeholder={genericAvatar}
                      alt={`${hiredPlacement.firstName} ${hiredPlacement.lastName}`}
                      width="100%"
                      loading="lazy"
                    />
                  </div>
                </Col>
                <Col className="d-flex align-items-center">
                  <div>
                    <h2>
                      {`${hiredPlacement.firstName} ${hiredPlacement.lastName} (Alumni)`}{" "}
                      <span className="light">
                        &apos;{(hiredPlacement.gradYear % 100).toString().padStart(2, "0")}
                      </span>
                    </h2>
                    <HiredPlacementSecondaryInfo hiredPlacement={hiredPlacement} />
                  </div>
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                  <div className="d-flex flex-column justify-content-center">
                    <Button
                      onClick={() =>
                        history.push(`map-view-admin/hired-placement-details/${hiredPlacement.id}`)
                      }
                      className="p-3"
                      variant="link"
                      size="lg"
                    >
                      Learn More
                      <i className="ml-2 fas fa-arrow-right" />
                    </Button>

                    <div className="buttons spaced-children">
                      <div className="buttons spaced-children">
                        <Button
                          variant="outline-success"
                          size="lg"
                          onClick={() => setIsShowingEditHiredPlacementModal(true)}
                        >
                          Edit
                        </Button>
                      </div>
                      <Button
                        variant="outline-danger"
                        size="lg"
                        onClick={() => setIsShowingConfirmDelete(true)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConfirmationModal
        title="Delete Member Profile?"
        message="Are you sure you want to delete this department member profile? This action cannot be undone."
        confirmText="Delete"
        variant="danger"
        show={isShowingConfirmDelete}
        onConfirm={() => {
          return deleteHiredStory(hiredPlacement.id).finally(() => {
            window.location.reload();
          });
        }}
        onHide={() => setIsShowingConfirmDelete(false)}
      />
      <AddEditHiredPlacementModal
        show={isShowingEditHiredPlacementModal}
        setShow={setIsShowingEditHiredPlacementModal}
        currentHiredPlacement={hiredPlacement}
      />
      <ErrorModal error={error} />
    </>
  );
}
